import { render, staticRenderFns } from "./OptionCard.vue?vue&type=template&id=dbb9ab08&scoped=true&"
import script from "./OptionCard.vue?vue&type=script&lang=ts&"
export * from "./OptionCard.vue?vue&type=script&lang=ts&"
import style0 from "./OptionCard.vue?vue&type=style&index=0&id=dbb9ab08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb9ab08",
  null
  
)

export default component.exports